// src/components/TraitsList.jsx
import React from 'react';
export default function TraitsList({ title, items }) {
  const isMain = title?.includes('메인');
  const parseBadge = (value) => {
    const str = String(value ?? '').trim();
    const m = str.match(/\((↑|↓)\s*([^)]+)\)\s*$/);
    if (!m) return { base: str, badge: null, dir: null };
    const num = parseFloat(m[2].replace(/[^0-9.-]/g, ''));
    if (isNaN(num) || num === 0) {
      return { base: str.replace(/\s*\((↑|↓)[^)]+\)\s*$/, '').trim(), badge: null, dir: null };
    }
    const dir = m[1] === '↑' ? 'up' : 'down';
    const base = str.replace(/\s*\((↑|↓)[^)]+\)\s*$/, '').trim();
    const badge = `${m[1]}${m[2]}`.replace(/\s+/g, '');
    return { base, badge, dir };
  };
  const badgeClass = (dir) =>
    dir === 'up'
      ? 'inline-flex items-center gap-x-1.5 rounded-md px-1.5 py-0.5 text-xs font-medium bg-red-500/15 text-red-700 dark:bg-red-400/10 dark:text-red-400'
      : 'inline-flex items-center gap-x-1.5 rounded-md px-1.5 py-0.5 text-xs font-medium bg-emerald-500/15 text-emerald-700 dark:bg-emerald-400/10 dark:text-emerald-300';

  const wrapperClass = isMain
    ? 'mt-4 grid gap-0 sm:gap-8 sm:grid-cols-2 xl:grid-cols-4'
    : 'mt-0 sm:mt-6 grid gap-y-0 sm:gap-y-3 gap-x-8 sm:grid-cols-2';

  return (
    <div>
      <div className={wrapperClass}>
        {items.map((it, i) => {
          const { base, badge, dir } = parseBadge(it.value);
          if (isMain) {
            return (
              <div key={`${it.trait}-${i}`} className='odd:bg-zinc-100/50 dark:odd:bg-zinc-800 sm:odd:bg-transparent dark:sm:odd:bg-transparent'>
                <hr
                  role="presentation"
                  className="w-full border-t border-zinc-950/10 dark:border-white/10"
                />
                <div className="flex items-center gap-2 mt-0 pt-4 px-4 sm:px-0 sm:mt-6 sm:pt-0 text-sm text-zinc-500 dark:text-zinc-400">
                  {it.trait}
                  {badge && (
                    <div className="text-sm/6 sm:text-xs/6">
                      <span className={badgeClass(dir)}>{badge}</span>
                    </div>
                  )}
                </div>
                {/* ✅ 다크모드 텍스트 색 명시 */}
                <div className="mt-2 sm:mt-3 text-2xl/8 pb-3 sm:pb-0 px-4 sm:px-0 font-semibold sm:text-2xl/8 text-zinc-950 dark:text-white tracking-tighter">
                  {base || it.value}
                </div>
              </div>
            );
          }
          return (
            <p
              key={`${it.trait}-${i}`}
              className="flex items-baseline justify-between border-t border-zinc-950/10 pt-3 text-sm/6 dark:border-white/10 px-4 sm:px-0 odd:bg-zinc-100/50 dark:odd:bg-zinc-800 sm:odd:bg-transparent dark:sm:odd:bg-transparent pb-3 sm:pb-0 "
            >
              <span className="flex items-center gap-2 font-medium text-zinc-800 dark:text-zinc-200">
                {it.trait}
                {badge && <span className={badgeClass(dir)}>{badge}</span>}
              </span>
              <span className="ml-3 text-zinc-900 dark:text-white">
                <span>{base || it.value}</span>
              </span>
            </p>
          );
        })}
      </div>
    </div>
  );
}
